export const home = {
  hero: {
    title: 'Poháňame globálnu energetickú',
    titleHighlight: 'infraštruktúru',
    description: 'Popredný dodávateľ a distribútor zemného plynu a elektriny, poskytujúci spoľahlivé energetické riešenia na medzinárodných trhoch s nekompromisným dôrazom na bezpečnosť a efektívnosť.',
    cta: 'Preskúmať riešenia',
    countriesServed: 'Obsluhovaných krajín',
    energyCapacity: 'Energetická kapacita',
    reliabilityRate: 'Miera spoľahlivosti'
  },
  services: {
    title: 'Komplexné energetické riešenia',
    subtitle: 'Od upstream sourcingu až po konečné dodanie poskytujeme integrované energetické služby, ktoré spĺňajú najnáročnejšie priemyselné a komerčné požiadavky.',
    naturalGas: {
      title: 'Dodávka zemného plynu',
      description: 'Komplexný upstream sourcing, hedgingové stratégie, správa zmlúv a spoľahlivé dodávky do strategických bodov na globálnych trhoch.',
      features: ['Upstream sourcing', 'Riadenie rizík', 'Správa zmlúv', 'Dodávateľské siete']
    },
    electricity: {
      title: 'Dodávka elektriny',
      description: 'Zmluvy o nákupe energie, služby vyvažovania siete, správa prístupu a pokročilé meracie riešenia pre priemyselných a komerčných klientov.',
      features: ['PPA štruktúry', 'Vyvažovanie siete', 'Správa prístupu', 'Inteligentné meranie']
    },
    infrastructure: {
      title: 'Infraštruktúrne riešenia',
      description: 'Komplexné potrubia, meracie stanice, implementácia SCADA a komplexné programy údržby pre energetickú infraštruktúru.',
      features: ['Potrubia', 'Meracie stanice', 'SCADA systémy', 'Programy údržby']
    },
    compliance: {
      title: 'Riziko a súlad',
      description: 'Regulačné hlásenia, monitorovanie emisií, implementácia bezpečnostných štandardov a komplexná správa súladu vo všetkých operáciách.',
      features: ['Regulačné hlásenia', 'Monitorovanie emisií', 'Bezpečnostné štandardy', 'Správa súladu']
    },
    learnMore: 'Zistiť viac'
  },
  stats: {
    title: 'Dôveryhodní pre priemyselných lídrov',
    subtitle: 'Náš záväzok k dokonalosti sa odráža v našich prevádzkových metrikách a dôvere, ktorú nám venujú globálni energetickí partneri.',
    countriesServed: 'Obsluhovaných krajín',
    countriesServedDesc: 'Globálna prítomnosť na hlavných energetických trhoch',
    energyCapacity: 'Energetická kapacita',
    energyCapacityDesc: 'Kombinovaná kapacita zemného plynu a elektriny',
    reliabilityRate: 'Miera spoľahlivosti',
    reliabilityRateDesc: 'Konzistentná prevádzková doba vo všetkých operáciách',
    enterpriseClients: 'Podnikových klientov',
    enterpriseClientsDesc: 'Dôveryhodní pre popredné priemyselné spoločnosti',
    yearsExperience: 'Rokov skúseností',
    yearsExperienceDesc: 'Overené výsledky na energetických trhoch',
    operationsCenter: 'Operačné centrum',
    operationsCenterDesc: 'Nepretržité monitorovanie a podpora',
    certifiedCompliant: 'Certifikovaní a v súlade'
  },
  cta: {
    title: 'Pripravení poháňať vaše operácie?',
    subtitle: 'Spojte sa s našimi energetickými špecialistami, aby ste prediskutovali vaše požiadavky a objavili, ako môžeme optimalizovať vašu energetickú infraštruktúru.',
    consultation: 'Naplánovať konzultáciu',
    brochure: 'Stiahnuť brožúru',
    callSales: 'Zavolať predaj',
    emailUs: 'Napísať email',
    address: 'Adresa'
  }
};
